import type { AreaRoutes } from "@/app/routes/hr/areaRoutes";

/* The lifecycle: onboarding and offboarding checklists, assets and HR letters. */
export const lifecycleRoutes: AreaRoutes = {
  people: [
    {
      path: "lifecycle",
      lazy: async () => ({
        Component: (await import("@/features/lifecycle/routes/LifecycleBoardPage")).default,
      }),
    },
    {
      path: "lifecycle/templates",
      lazy: async () => ({
        Component: (await import("@/features/lifecycle/routes/ChecklistTemplatesPage")).default,
      }),
    },
    {
      path: "assets",
      lazy: async () => ({
        Component: (await import("@/features/lifecycle/routes/AssetsPage")).default,
      }),
    },
    {
      path: "letters",
      lazy: async () => ({
        Component: (await import("@/features/lifecycle/routes/LettersPage")).default,
      }),
    },
    {
      path: "letters/templates",
      lazy: async () => ({
        Component: (await import("@/features/lifecycle/routes/LetterTemplatesPage")).default,
      }),
    },
    {
      path: "letters/:requestId",
      lazy: async () => ({
        Component: (await import("@/features/lifecycle/routes/LetterPage")).default,
      }),
    },
  ],
  employee: [
    {
      path: "lifecycle",
      lazy: async () => ({
        Component: (await import("@/features/lifecycle/routes/EmployeeLifecycleTab")).default,
      }),
    },
  ],
  me: [
    {
      path: "letters",
      lazy: async () => ({
        Component: (await import("@/features/lifecycle/routes/MyLettersPage")).default,
      }),
    },
    {
      path: "letters/:requestId",
      lazy: async () => ({
        Component: (await import("@/features/lifecycle/routes/MyLetterPage")).default,
      }),
    },
  ],
  top: [],
};
